import Enum from './Enum.js';

export default class HyundaiSegments extends Enum {
    static get entries() {
        return {
            'Lease-End Customer Intent & Maturity Reminder - 6-Months to Maturity':
                'Lease-End Customer Intent & Maturity Reminder - 6-Months to Maturity',
            'Lease-End Customer Intent & Maturity Reminder - 3-Months to Maturity':
                'Lease-End Customer Intent & Maturity Reminder - 3-Months to Maturity',
            'Lease-End Customer Intent & Maturity Reminder - Customer Intent - Undecided':
                'Lease-End Customer Intent & Maturity Reminder - Customer Intent - Undecided',
            'Lease-End Customer Intent & Maturity Reminder - Customer Intent - New Hyundai Purchase':
                'Lease-End Customer Intent & Maturity Reminder - Customer Intent - New Hyundai Purchase',
            'Lease-End Customer Intent & Maturity Reminder - Customer Intent - New Hyundai Lease':
                'Lease-End Customer Intent & Maturity Reminder - Customer Intent - New Hyundai Lease',
            'Lease Ending Program - Customer Intent - Undecided':
                'Lease Ending Program - Customer Intent - Undecided',
            'Lease Ending Program - Lease Pull-Ahead Promotion':
                'Lease Ending Program - Lease Pull-Ahead Promotion',
            'Lease Ending Program - Lease Ending Direct Mail Offer':
                'Lease Ending Program - Lease Ending Direct Mail Offer',
            'Lease Ending Program - Customer Intent - New Hyundai Lease':
                'Lease Ending Program - Customer Intent - New Hyundai Lease',
            'Lease Ending Program - Customer Intent - New Hyundai Purchase':
                'Lease Ending Program - Customer Intent - New Hyundai Purchase',
        };
    }
}
